<div class="position-reletivediv register-panel-root">
  <div class="popup-inner-space border-bottom-grey">
    <div class="betweenheader text-dark"> Meter Configuration - {{this.selectedmetername}} </div>
    <div class="text-right flow-right"><img src="../../../assets/images/close_icon.svg" alt="..."
        class="img-fluid closeicon2 cursor-pointer" (click)="Close()"></div>
  </div>

  <mat-tab-group *ngIf="CompanyCode=='insight'">

    <mat-tab label="Register Configuration">
      <div class="register-panel-layout">

        <div class="popup-inner-space" style="margin-top: 10px!important;">
          <div class="errmsg error-register" *ngIf="errorMsg">{{errorMsg}}</div>
          <div class="sucessmsg  error-register" *ngIf="successMsg">{{successMsg}}</div>
        </div>
        <form [formGroup]="registerpanelForm" class="width100 register-panel-form" id="registerpanelForm">
          <div class="d-flex justify-content-between">
            <div class="fxg-field register-form-container">

              <div>
                <div class="fxg-field margin-top-5 pr-0 col-lg-2 padding-space">
                  <mat-label>Channel No.</mat-label>
                  <mat-select class="matselect text-center" name="fcode" id="fcode" formControlName="SlaveID"
                    required="" aria-required="true" #SlveId (focus)="SlveId.focus()"
                    (selectionChange)="OnSlveId($event)">
                    <mat-option *ngFor="let item of devicecounterlist" [value]="item">{{ item
                      }}</mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
          </div>

          <div class="table-body-main mx-3 register-table-scroll-wrapper register-panel-table-area">
            <table class="table-main-register table register-panel-table register-panel-analog" *ngIf="flag==false" id="tableregisterpanel">
                <colgroup>
                  <col style="width:9%"><col style="width:5%"><col style="width:6%"><col style="width:5%">
                  <col style="width:5%"><col style="width:5%"><col style="width:9%"><col style="width:7%">
                  <col style="width:6%"><col style="width:7%"><col style="width:8%"><col style="width:5%">
                  <col style="width:5%"><col style="width:7%"><col style="width:6%"><col style="width:6%">
                </colgroup>
                <thead class="thead-data" id="theadregisterpanel">
                  <tr>
                  <th class="font_14 color_black" id="thregisterRegName">Register name</th>
                  <th class="font_14 color_black" id="thregisterRegNo">Register no</th>
                  <th class="font_14 color_black" id="thregisterUnit">Unit</th>
                  <th class="font_14 color_black" id="thregisterZeroScale">Zero scale</th>
                  <th class="font_14 color_black" id="thregisterFullScale">Full scale</th>
                  <th class="font_14 color_black" id="thregisterLocation">Location</th>
                  <th class="font_14 color_black" id="thregisterDataType">Data type</th>
                  <th class="font_14 color_black" id="thregisterfunctionCode">Function code</th>
                  <th class="font_14 color_black" id="thregisterDecimalPoint">Decimal point</th>
                  <th class="font_14 color_black" id="thregisterDecimalPointfront">Decimal point (front)</th>
                  <th class="font_14 color_black" id="thregisterAction">Read/write action</th>
                  <th class="font_14 color_black register-checkbox-head" id="thregisterIsDisplaygraph">Is display graph</th>
                  <th class="font_14 color_black register-checkbox-head" id="thregisterIsTotalizer">Is totalizer</th>
                  <th class="font_14 color_black" id="thregisterAlert">Alert</th>
                  <th class="font_14 color_black" id="thregisterHighValue">High value</th>
                  <th class="font_14 color_black" id="thregisterLowValue">Low value</th>
                  </tr>
                </thead>
                <tbody formArrayName="listRegisterdata"
                  id="tableregisterlistRegisterdata">
                  <ng-container
                    *ngFor="let maxb of registerpanelForm['controls'].listRegisterdata['controls'];let i = index"
                    formGroupName="{{i}}">
                    <tr id="{{ 'trregisterlistRegisterdata' + i }}">
                      <td id="{{ 'tdregisterlistRegisterName' + i }}" class="width-fix-table width12"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].RegisterName.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input
                               fxg-field__input-text fxg-field__input--required input-space
                               sessioncamexclude" name="rname" id="{{ 'rname' + i }}" formControlName="RegisterName"
                          [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          #rname (focus)="rname.focus()" />
                        <p class="error_msg" *ngIf="ListdisplayMessage.RegisterName" id="{{ 'rname' + i }}">
                          {{ListdisplayMessage.RegisterName}}
                        </p>
                      </td>
                      <td class="width-fix-table position-reletivediv width10"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].RegisterNO.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input input-space
                               fxg-field__input-text fxg-field__input--required
                               sessioncamexclude" name="rnumber" id="rnumber" formControlName="RegisterNO" OnlyNumber
                          [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          #rno (focus)="rno.focus()" />

                      </td>
                      <td class="width-fix-table position-reletivediv register-unit-cell"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].Unit.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input register-unit-input input-space
                             fxg-field__input-text fxg-field__input--required sessioncamexclude"
                          name="unit" id="{{ 'unit' + i }}" formControlName="Unit" maxlength="50" #unitInput
                          [matAutocomplete]="unitAuto" placeholder="Select unit"
                          [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          (focus)="unitInput.focus()" />
                        <mat-autocomplete #unitAuto="matAutocomplete" panelClass="register-panel-autocomplete-panel"
                          (optionSelected)="OnChange('unit')">
                          <mat-option *ngFor="let lstunit of UnitList" [value]="lstunit.CodeDisplayName">
                            {{ lstunit.CodeDisplayName }}
                          </mat-option>
                        </mat-autocomplete>
                      </td>
                      <td class="width-fix-table position-reletivediv width7"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ZeroScale.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input input-space
                                               fxg-field__input-text fxg-field__input--required
                                               sessioncamexclude" name="ZeroScale" id="ZeroScale"
                          formControlName="ZeroScale" type="number" maxlength="20" #ZeroScale
                          (focus)="ZeroScale.focus()" />

                      </td>
                      <td class="width-fix-table position-reletivediv width7"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].FullScale.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input input-space
                                                               fxg-field__input-text fxg-field__input--required
                                                               sessioncamexclude" name="FullScale" id="FullScale"
                          type="number" formControlName="FullScale" maxlength="20" #FullScale
                          (focus)="FullScale.focus()" />

                      </td>
                      <td class="width-fix-table position-reletivediv width7"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].Location.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input input-space
                                                                                 fxg-field__input-text fxg-field__input--required
                                                                                 sessioncamexclude" name="Location"
                          id="Location" type="number" formControlName="Location" maxlength="20" #Location
                          (focus)="Location.focus()" />

                      </td>
                      <td class="width12"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DataType.status == 'INVALID' && isSaveClick}">
                        <mat-select class="mat-space focus-input" name="datatype" id="datatype"
                          formControlName="DataType" required="" aria-required="true" #dataType
                          (focus)="dataType.focus()"
                          [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          (selectionChange)="OnChange('dataType')">
                          <mat-option value="">(Select DataType)</mat-option>
                          <mat-option MatFormFieldControl="datatype" *ngFor="let lstdatatype of DatatypeList"
                            [value]="lstdatatype.CodeDescription">
                            {{lstdatatype.CodeDisplayName}}
                          </mat-option>
                        </mat-select>
                      </td>
                      <td class="width8"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].FunctionCode.status == 'INVALID' && isSaveClick}">
                        <mat-select class="focus-input" name="fcode" id="fcode" formControlName="FunctionCode"
                          required=""
                          [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          aria-required="true" class="mat-space focus-input" #fcode (focus)="fcode.focus()"
                          (selectionChange)="OnChange('FunctionCode')">
                          <mat-option value="">(Select Function Code)</mat-option>
                          <mat-option MatFormFieldControl="fcode" *ngFor="let lstfunctioncode of FunctionCodeList"
                            [value]="lstfunctioncode.CodeValue">
                            {{lstfunctioncode.CodeDisplayName}}
                          </mat-option>
                        </mat-select>
                      </td>
                      <td class="width8"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DecimalPoint.status == 'INVALID' && isSaveClick}">
                        <mat-select class="mat-space focus-input" name="dpoint" id="dpoint"
                          formControlName="DecimalPoint" required="" aria-required="true" #Dpoint
                          (focus)="Dpoint.focus()"
                          [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          (selectionChange)="OnChange('DecimalPoint')">
                          <mat-option value="">(Select Decimal Point)</mat-option>
                          <mat-option MatFormFieldControl="dpoint" *ngFor="let lstdecimalpoint of DecimalPointList"
                            [value]="lstdecimalpoint.CodeValue">
                            {{lstdecimalpoint.CodeDisplayName}}
                          </mat-option>
                        </mat-select>
                      </td>
                      <td class="width10"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DecimalPointForFront.status == 'INVALID' && isSaveClick}">
                        <mat-select class="mat-space focus-input" name="dpointfront" id="dpointfront"
                          formControlName="DecimalPointForFront" required="" aria-required="true" #DpointFront
                          (focus)="DpointFront.focus()" (selectionChange)="OnChange('DecimalPointForFront')">
                          <mat-option value="">(Select Decimal Point)</mat-option>
                          <mat-option MatFormFieldControl="dpointfront"
                            *ngFor="let lstdecimalpoint of DecimalPointFrontList" [value]="lstdecimalpoint.CodeValue">
                            {{lstdecimalpoint.CodeDisplayName}}
                          </mat-option>
                        </mat-select>
                      </td>
                      <td class="width10"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                        <mat-select class="mat-space focus-input" name="ReadWriteAction" id="ReadWriteAction"
                          formControlName="ReadWriteAction" required="" aria-required="true" #action
                          (focus)="action.focus()" (selectionChange)="OnChange('ReadWriteAction')"
                          [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'">
                          <mat-option value="">(Select Action)</mat-option>
                          <mat-option MatFormFieldControl="ReadWriteAction" *ngFor="let lstactionpoint of ActionList"
                            [value]="lstactionpoint.CodeValue">
                            {{lstactionpoint.CodeDisplayName}}
                          </mat-option>
                        </mat-select>
                      </td>
                      <td class="register-checkbox-cell">
                        <input type="checkbox" class="register-row-checkbox cursor-pointer"
                          formControlName="IsDisplayGraph" #display (focus)="display.focus()"
                          [disabled]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'" />
                      </td>
                      <td class="register-checkbox-cell">
                        <input type="checkbox" class="register-row-checkbox cursor-pointer"
                          formControlName="IsTotalizer" #isTotalizer (focus)="isTotalizer.focus()"
                          [disabled]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'" />
                      </td>
                      <td class="width10 register-alert-cell"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].AlertId.status == 'INVALID' && isSaveClick}">
                        <mat-select class="mat-space focus-input" formControlName="AlertId" [compareWith]="compareAlertId"
                          [disabled]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'">
                          <mat-option value="">(Select Alert)</mat-option>
                          <mat-option *ngFor="let alert of AlertList" [value]="+alert.AlertId">
                            {{ alert.AlertName }}
                          </mat-option>
                        </mat-select>
                      </td>
                      <td class="width-fix-table position-reletivediv width8"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input fxg-field__input-text fxg-field__input--required
                                             sessioncamexclude" name="rnumber1" id="rnumber1"
                          formControlName="HighThresoldValue" NumberWithDecimal maxlength="50"
                          [ngClass]="{'cursor-pointer-none' : IsreadOnly }" #threshold1
                          [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          (focus)="threshold1.focus()" />
                      </td>

                      <td class="width-fix-table position-reletivediv width8"
                        [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                        <input class="focus-input fxg-field__input-text fxg-field__input--required
                                                               sessioncamexclude" name="rnumber1" id="rnumber1"
                          formControlName="LowThresoldValue" NumberWithDecimal maxlength="50"
                          [ngClass]="{'cursor-pointer-none' : IsreadOnly }" #threshold2
                          [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                          (focus)="threshold2.focus()" />
                      </td>
                      <!-- <div   > -->

                      <!-- </div> -->
                    </tr>
                  </ng-container>
                </tbody>
            </table>
          </div>
        </form>

      <div class="d-flex justify-content-between px-3 register-panel-footer">

        <div class="margin-top-20 d-flex" *ngIf="DisplayButton">
          <!-- <button class="btncommon-grey mr-2  btn-border-add-company width-fix67" style="padding: 0px 10px;" type="button"
                value="show" (click)="DownloadSampleExcel()" id="show_fields" *ngIf="DisplayButton">Download Sample
                File</button>
              <button class="btncommon-grey btn-border-add-company width-fix67" type="button" value="show"
                (click)="OnImport(maxrefvalue.value)" id="show_fields" *ngIf="DisplayButton">Import Excel</button>
              <button class="btncommon-grey btn-border-add-company width-fix67 ml-2" type="button" value="show"
                (click)="AddNewParameterConfig(0,i)" id="show_fields" style="padding: 0px 10px;" *ngIf="DisplayButton">Add
                Formula</button>
              <div class="errmsg" id="addformulamsg" *ngIf="isDivVisible && (data.EnergyMeterdata.EMID==0)   ">
                {{Addformulamsg}}</div> -->

        </div>

        <div class="d-flex">
          <!-- *ngIf="DisplayButton" -->

          <button class="btncommon width-fix67" (click)="OnSubmit()">Save</button>
          <button class="btn-orange btncommon btn-orange-SendToMail12 width-fix67"
            [ngClass]="{'disablesend' : IsChange == true}" type="button" (click)="SendRegisterJSON()">Send</button>
          <button class="btncommon-grey  btn-border-add-company width-fix67" (click)="OnCancel()">Cancel</button>
        </div>


      </div>
      </div>
    </mat-tab>
    <mat-tab label="Device Settings">
      <div class="margin-top-20">



        <div class="popup-inner-space" style="margin-top: 46px!important;">
          <div class=" errmsg error-register" *ngIf="errorMsgdevice">{{errorMsgdevice}}</div>
          <div class="sucessmsg  error-register" *ngIf="successMsgdevice">{{successMsgdevice}}</div>
        </div>
        <form [formGroup]="deviceSettingsForm" class="width100" id="deviceSettingsForm">



          <div class="d-flex justify-content-between">
            <div class="fxg-field register-form-container">


              <div class="row" style="height: 310px!important;">
                <div class="col-lg-2"
                  style="max-width: 100%!important;width: 100%!important;padding-right: 0!important;">

                  <div class="fxg-field margin-top-5 pr-0 col-lg-2 padding-space digitalmetertopfields "
                    style="max-width: 100%!important;width: 100%!important;">
                    <label style="display:none;" class="Navuser">Serial Number </label>
                    <input class="fxg-field__input-text fxg-field__input--required sessioncamexclude popup-input-width "
                      type="text" #Bvalue required name="SerialNumber" id="SerialNumber" formControlName="SerialNumber"
                      [readonly]="IsreadOnly" />
                    <span class="fxg-field__placeholder fxg-field__placeholder12 fxg-field__floating-placeholder"
                      tabindex="-1">Serial Number</span>
                    <div style="position: relative;">

                      <p class="error_msg " *ngIf="displayMessage.SerialNumber">
                        {{displayMessage.SerialNumber}}
                      </p>
                      <p class="error_msg error-msg-position" *ngIf="SlaveMessage">{{SlaveMessage}}</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3" style="padding-right: 0!important">


                  <mat-form-field style="width:100%" class="calendar margin-right-5 margin-top-5">
                    <input formControlName="LastCalibrationDate" id="LastCalibrationDate" name="LastCalibrationDate"
                      class="mat-date-picker-device" matInput #ref [matDatepicker]="picker1"
                      placeholder="Last Calibration Date" [min]="minDate" (dateChange)="OnChangeDate"
                      [ngClass]="{'cursor-pointer-none' : IsreadOnly}" [maxlength]="8" />
                    <mat-datepicker-toggle matSuffix [for]="picker1" class="date-ic-flow-graph " style="top: 4px;">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1 class="picker112" id="pickermat"></mat-datepicker>
                  </mat-form-field>


                </div>
                <div class="col-lg-3" style="padding-right: 0!important">

                  <mat-form-field style="width:100%" class="calendar margin-right-5 margin-top-5">
                    <input formControlName="LastCalibrationDueDate" id="LastCalibrationDueDate"
                      name="LastCalibrationDueDate" matInput #ref [matDatepicker]="picker2"
                      class="mat-date-picker-device" placeholder="Last Calibration Due Date" [min]="minDate"
                      style="width: 200px;" />
                    <mat-datepicker-toggle matSuffix [for]="picker2" class="date-ic-flow-graph" style="top: 4px;">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker2 class="picker112" id="pickermat"></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="col-lg-4" style="padding-right: 0!important">

                  <div class="fxg-field logo-section margin-top-5 width78 margin-right-4"
                    style="height: 38px!important;">
                    <label class="logo-section-label" id="Upload">
                      {{ CalibrationCertificatefilename ? CalibrationCertificatefilename : 'Upload Calibration
                      Certificate'
                      }}
                    </label>

                    <img class="uploadiconimg" src="/assets/images/upload-icon.svg"
                      (click)="UploadCalibrationCertificate()" id="uploadiconimg">
                    <!-- <label class="inputlabel" id="inputlabel">{{CalibrationCertificatefilename}}</label> -->
                    <img class="logoimg" src="">
                  </div>
                </div>
              </div>




            </div>
          </div>

        </form>

        <div class="d-flex justify-content-between px-3">
          <div class="d-flex">
            <div class="margin-top-20 d-flex" *ngIf="DisplayButton">


            </div>
          </div>
          <div class="d-flex">
            <div class="margin-top-20 d-flex" *ngIf="DisplayButton">
              <button class="btncommon width-fix67 margin-right-10" (click)="SaveDeviceSettings()">Save</button>

              <button class="btncommon-grey  btn-border-add-company width-fix67" (click)="OnCancel()">Cancel</button>
            </div>
          </div>

        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="register-panel-layout" *ngIf="CompanyCode !='insight'">
  <div class="popup-inner-space">
    <div class="errmsg error-register" *ngIf="errorMsg">{{errorMsg}}</div>
    <div class="sucessmsg  error-register" *ngIf="successMsg">{{successMsg}}</div>
  </div>
  <form [formGroup]="registerpanelForm" class="width100 register-panel-form" id="registerpanelFormNonInsight">
    <div class="d-flex justify-content-between">
      <div class="fxg-field register-form-container">

        <div>
          <div class="fxg-field margin-top-5 pr-0 col-lg-2 padding-space">
            <mat-label>Channel No.</mat-label>
            <mat-select class="matselect text-center" name="fcode" id="fcode" formControlName="SlaveID" required=""
              aria-required="true" #SlveId (focus)="SlveId.focus()" (selectionChange)="OnSlveId($event)">
              <mat-option *ngFor="let item of devicecounterlist" [value]="item">{{ item
                }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-main mx-3 register-table-scroll-wrapper register-panel-table-area">
      <table class="table-main-register table register-panel-table register-panel-analog" *ngIf="flag==false" id="tableregisterpanel">
          <colgroup>
            <col style="width:9%"><col style="width:5%"><col style="width:6%"><col style="width:5%">
            <col style="width:5%"><col style="width:5%"><col style="width:9%"><col style="width:7%">
            <col style="width:6%"><col style="width:7%"><col style="width:8%"><col style="width:5%">
            <col style="width:5%"><col style="width:7%"><col style="width:6%"><col style="width:6%">
          </colgroup>
          <thead class="thead-data" id="theadregisterpanel">
            <tr>
            <th class="font_14 color_black" id="thregisterRegName">Register name</th>
            <th class="font_14 color_black" id="thregisterRegNo">Register no</th>
            <th class="font_14 color_black" id="thregisterUnit">Unit</th>
            <th class="font_14 color_black" id="thregisterZeroScale">Zero scale</th>
            <th class="font_14 color_black" id="thregisterFullScale">Full scale</th>
            <th class="font_14 color_black" id="thregisterLocation">Location</th>
            <th class="font_14 color_black" id="thregisterDataType">Data type</th>
            <th class="font_14 color_black" id="thregisterfunctionCode">Function code</th>
            <th class="font_14 color_black" id="thregisterDecimalPoint">Decimal point</th>
            <th class="font_14 color_black" id="thregisterDecimalPointfront">Decimal point (front)</th>
            <th class="font_14 color_black" id="thregisterAction">Read/write action</th>
            <th class="font_14 color_black register-checkbox-head" id="thregisterIsDisplaygraph">Is display graph</th>
            <th class="font_14 color_black register-checkbox-head" id="thregisterIsTotalizer">Is totalizer</th>
            <th class="font_14 color_black" id="thregisterAlert">Alert</th>
            <th class="font_14 color_black" id="thregisterHighValue">High value</th>
            <th class="font_14 color_black" id="thregisterLowValue">Low value</th>
            </tr>
          </thead>
          <tbody formArrayName="listRegisterdata"
            id="tableregisterlistRegisterdata">
            <ng-container *ngFor="let maxb of registerpanelForm['controls'].listRegisterdata['controls'];let i = index"
              formGroupName="{{i}}">
              <tr id="{{ 'trregisterlistRegisterdata' + i }}">
                <td id="{{ 'tdregisterlistRegisterName' + i }}" class="width-fix-table width12"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].RegisterName.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input
                       fxg-field__input-text fxg-field__input--required input-space
                       sessioncamexclude" name="rname" id="{{ 'rname' + i }}" formControlName="RegisterName"
                    [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    #rname (focus)="rname.focus()" />
                  <p class="error_msg" *ngIf="ListdisplayMessage.RegisterName" id="{{ 'rname' + i }}">
                    {{ListdisplayMessage.RegisterName}}
                  </p>
                </td>
                <td class="width-fix-table position-reletivediv width10"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].RegisterNO.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                       fxg-field__input-text fxg-field__input--required
                       sessioncamexclude" name="rnumber" id="rnumber" formControlName="RegisterNO" OnlyNumber
                    [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    #rno (focus)="rno.focus()" />

                </td>
                <td class="width-fix-table position-reletivediv register-unit-cell"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].Unit.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input register-unit-input input-space
                       fxg-field__input-text fxg-field__input--required sessioncamexclude"
                    name="unit" id="{{ 'unit' + i }}" formControlName="Unit" maxlength="50" #unitInput
                    [matAutocomplete]="unitAuto" placeholder="Select unit"
                    [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    (focus)="unitInput.focus()" />
                  <mat-autocomplete #unitAuto="matAutocomplete" panelClass="register-panel-autocomplete-panel"
                    (optionSelected)="OnChange('unit')">
                    <mat-option *ngFor="let lstunit of UnitList" [value]="lstunit.CodeDisplayName">
                      {{ lstunit.CodeDisplayName }}
                    </mat-option>
                  </mat-autocomplete>
                </td>
                <td class="width-fix-table position-reletivediv width7"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ZeroScale.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                                       fxg-field__input-text fxg-field__input--required
                                       sessioncamexclude" name="ZeroScale" id="ZeroScale" formControlName="ZeroScale"
                    type="number" maxlength="20" #ZeroScale (focus)="ZeroScale.focus()" />

                </td>
                <td class="width-fix-table position-reletivediv width7"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].FullScale.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                                                       fxg-field__input-text fxg-field__input--required
                                                       sessioncamexclude" name="FullScale" id="FullScale" type="number"
                    formControlName="FullScale" maxlength="20" #FullScale (focus)="FullScale.focus()" />

                </td>
                <td class="width-fix-table position-reletivediv width7"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].Location.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input input-space
                                                                         fxg-field__input-text fxg-field__input--required
                                                                         sessioncamexclude" name="Location"
                    id="Location" type="number" formControlName="Location" maxlength="20" #Location
                    (focus)="Location.focus()" />

                </td>
                <td class="width12"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DataType.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="datatype" id="datatype" formControlName="DataType"
                    required="" aria-required="true" #dataType (focus)="dataType.focus()"
                    [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    (selectionChange)="OnChange('dataType')">
                    <mat-option value="">(Select DataType)</mat-option>
                    <mat-option MatFormFieldControl="datatype" *ngFor="let lstdatatype of DatatypeList"
                      [value]="lstdatatype.CodeDescription">
                      {{lstdatatype.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width8"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].FunctionCode.status == 'INVALID' && isSaveClick}">
                  <mat-select class="focus-input" name="fcode" id="fcode" formControlName="FunctionCode" required=""
                    [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    aria-required="true" class="mat-space focus-input" #fcode (focus)="fcode.focus()"
                    (selectionChange)="OnChange('FunctionCode')">
                    <mat-option value="">(Select Function Code)</mat-option>
                    <mat-option MatFormFieldControl="fcode" *ngFor="let lstfunctioncode of FunctionCodeList"
                      [value]="lstfunctioncode.CodeValue">
                      {{lstfunctioncode.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width8"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DecimalPoint.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="dpoint" id="dpoint" formControlName="DecimalPoint"
                    required="" aria-required="true" #Dpoint (focus)="Dpoint.focus()"
                    [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    (selectionChange)="OnChange('DecimalPoint')">
                    <mat-option value="">(Select Decimal Point)</mat-option>
                    <mat-option MatFormFieldControl="dpoint" *ngFor="let lstdecimalpoint of DecimalPointList"
                      [value]="lstdecimalpoint.CodeValue">
                      {{lstdecimalpoint.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width10"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].DecimalPointForFront.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="dpointfront" id="dpointfront"
                    formControlName="DecimalPointForFront" required="" aria-required="true" #DpointFront
                    (focus)="DpointFront.focus()" (selectionChange)="OnChange('DecimalPointForFront')">
                    <mat-option value="">(Select Decimal Point)</mat-option>
                    <mat-option MatFormFieldControl="dpointfront" *ngFor="let lstdecimalpoint of DecimalPointFrontList"
                      [value]="lstdecimalpoint.CodeValue">
                      {{lstdecimalpoint.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width10"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" name="ReadWriteAction" id="ReadWriteAction"
                    formControlName="ReadWriteAction" required="" aria-required="true" #action (focus)="action.focus()"
                    (selectionChange)="OnChange('ReadWriteAction')"
                    [disabled]="registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'">
                    <mat-option value="">(Select Action)</mat-option>
                    <mat-option MatFormFieldControl="ReadWriteAction" *ngFor="let lstactionpoint of ActionList"
                      [value]="lstactionpoint.CodeValue">
                      {{lstactionpoint.CodeDisplayName}}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="register-checkbox-cell">
                  <input type="checkbox" class="register-row-checkbox cursor-pointer"
                    formControlName="IsDisplayGraph" #display (focus)="display.focus()"
                    [disabled]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'" />
                </td>
                <td class="register-checkbox-cell">
                  <input type="checkbox" class="register-row-checkbox cursor-pointer"
                    formControlName="IsTotalizer" #isTotalizer (focus)="isTotalizer.focus()"
                    [disabled]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'" />
                </td>
                <td class="width10 register-alert-cell"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].AlertId.status == 'INVALID' && isSaveClick}">
                  <mat-select class="mat-space focus-input" formControlName="AlertId" [compareWith]="compareAlertId"
                    [disabled]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'">
                    <mat-option value="">(Select Alert)</mat-option>
                    <mat-option *ngFor="let alert of AlertList" [value]="+alert.AlertId">
                      {{ alert.AlertName }}
                    </mat-option>
                  </mat-select>
                </td>
                <td class="width-fix-table position-reletivediv width8"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input fxg-field__input-text fxg-field__input--required
                                     sessioncamexclude" name="rnumber1" id="rnumber1"
                    formControlName="HighThresoldValue" NumberWithDecimal maxlength="50"
                    [ngClass]="{'cursor-pointer-none' : IsreadOnly }" #threshold1
                    [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    (focus)="threshold1.focus()" />
                </td>

                <td class="width-fix-table position-reletivediv width8"
                  [ngClass]="{'errorborder' : registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].ReadWriteAction.status == 'INVALID' && isSaveClick}">
                  <input class="focus-input fxg-field__input-text fxg-field__input--required
                                                       sessioncamexclude" name="rnumber1" id="rnumber1"
                    formControlName="LowThresoldValue" NumberWithDecimal maxlength="50"
                    [ngClass]="{'cursor-pointer-none' : IsreadOnly }" #threshold2
                    [readonly]="IsreadOnly || registerpanelForm['controls'].listRegisterdata['controls'][i]['controls'].IsFromParameterConfig.value == 'Y'"
                    (focus)="threshold2.focus()" />
                </td>
                <!-- <div   > -->

                <!-- </div> -->
              </tr>
            </ng-container>
          </tbody>
      </table>
    </div>
  </form>

  <div class="d-flex justify-content-between px-3 register-panel-footer">

    <div class="margin-top-20 d-flex" *ngIf="DisplayButton">
      <!-- <button class="btncommon-grey mr-2  btn-border-add-company width-fix67" style="padding: 0px 10px;" type="button"
        value="show" (click)="DownloadSampleExcel()" id="show_fields" *ngIf="DisplayButton">Download Sample
        File</button>
      <button class="btncommon-grey btn-border-add-company width-fix67" type="button" value="show"
        (click)="OnImport(maxrefvalue.value)" id="show_fields" *ngIf="DisplayButton">Import Excel</button>
      <button class="btncommon-grey btn-border-add-company width-fix67 ml-2" type="button" value="show"
        (click)="AddNewParameterConfig(0,i)" id="show_fields" style="padding: 0px 10px;" *ngIf="DisplayButton">Add
        Formula</button>
      <div class="errmsg" id="addformulamsg" *ngIf="isDivVisible && (data.EnergyMeterdata.EMID==0)   ">
        {{Addformulamsg}}</div> -->

    </div>

    <div class="d-flex">
      <!-- *ngIf="DisplayButton" -->

      <button class="btncommon width-fix67" (click)="OnSubmit()">Save</button>
      <button class="btn-orange btncommon btn-orange-SendToMail12 width-fix67"
        [ngClass]="{'disablesend' : IsChange == true}" type="button" (click)="SendRegisterJSON()">Send</button>
      <button class="btncommon-grey  btn-border-add-company width-fix67" (click)="OnCancel()">Cancel</button>
    </div>


  </div>
  </div>
</div>